import { POS_ORDER_TYPE } from '../static'
import { formatServedByNames, getServedByUsersFromData } from '../servedBy'

/**
 * Pegawai "Dilayani Oleh" untuk struk thermal / plain (matches OrderDetail + API order_type_data.users).
 * Bila tidak muat `maxLength`, diringkas jadi "Budi, Sari +2" (bukan dipotong "...").
 */
export const getServedByNamesForReceipt = (data, maxLength = 22) => {
  if (!data) {
    return ''
  }
  const typeId =
    data.order_type_id ?? data.invoice_type_id ?? data.order_type?.id ?? data.invoice_type?.id
  if (`${typeId ?? ''}` !== `${POS_ORDER_TYPE.SERVED_BY}`) {
    return ''
  }
  const users = getServedByUsersFromData(data)
  for (let max = users.length; max > 1; max -= 1) {
    const text = formatServedByNames(users, max)
    if (text.length <= maxLength) {
      return text
    }
  }
  return formatServedByNames(users, 1)
}
